<template>
  <carousel
    v-bind:scrollPerPage="true"
    v-bind:autoplay="true"
    v-bind:autoplayTimeout=5000
    v-bind:speed=3000
    v-bind:loop="true"
    v-bind:centerMode="true"
    v-bind:per-page-custom="[
      [280, 1],
      [480, 1],
      [780, 2],
      [1024, 3],
    ]"
  >
    <slide class="px-5" v-for="(item, index) in elements" :key="index">
      <div class="relative rounded font-lato max-h-80">
        <img
          v-if="app.webp_support"
          class="w-full object-cover"
          style="height: 16rem"
          :src="item.image_webp_url"
          :alt="item.name"
          width="345"
          height="256"

        />
        <img
          v-else
          class="w-full object-cover"
          style="height: 16rem"
          :src="item.image_url"
          :alt="item.name"
          width="345"
          height="256"
        />
        <span
          v-if="item.geo_amount !== null"
          class="
            top-0
            left-0
            px-5
            py-1
            font-lato
            text-xs
            absolute
            bg-black bg-opacity-50
            text-white
          "
          >From {{ item.geo_amount }} {{ item.geo_currency }}
        </span>
        <div class="bottom-0 absolute w-full bg-black p-2 bg-opacity-75">
          <div class="float-left text-left font-lato text-xs">
            <a href="" class="text-orange tracking-tight text-500">{{
              item.name
            }}</a
            ><br />
            <span class="text-white text-left font-lato text-xs"
              >{{ item.city_name }} | {{ item.country_name }}</span
            >
          </div>
          <a
            :href="item.book_now_url"
            class="bg-orange float-right text-white p-2 text-xs"
            >BOOK NOW</a
          >
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["elements", "app"],
  components: {
    Carousel,
    Slide,
  },
};
</script>
